export const numfmt = (num) => {
    return (num
        .split('').reverse().join('')
        .replace(/([0-9]{3})/g, '$1 ')
        .split('').reverse().join(''));
};
